import { UserDetailsResult } from '../store/customers/types';
import { useFamilonetApi } from './useFamilonetApi';

export const useUserDetails = (
  userId?: string
): { result?: UserDetailsResult; error: string; loading: boolean } => {
  const path = userId ? `/api/v4/useradmin/${userId}/` : undefined;
  return useFamilonetApi<UserDetailsResult>({ method: 'GET', path });
};
